// extracted by css-extract-rspack-plugin
export default {"root":"k6xqXn","heading-and-description":"iTX_cM","headingAndDescription":"iTX_cM","content":"_gT8f3"};